import { apiClient } from "@/api/api-client";
import { Button } from "@/components/core/buttons/button";
import { Form, FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage, FormPrepend } from "@/components/core/forms/form.tsx";
import TagsInput from "@/components/core/forms/tags-input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
// import { caseTypesQueryOptions } from "@/features/dashboard/api/queries/case-type-queries";
import { caseDownloadPrintedScheduleMutation } from "@/features/dashboard/api/queries/event-queries";
import { downloadFile } from "@/utils/download-file";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Checkbox } from "../core/forms/checkbox";

export default function CaseCalendarPrintModal({
	data,
	branchId,
	date,
	calendarIds,
}: { data?: string; branchId?: string; date?: string; calendarIds?: string[] }) {
	const { closeModal } = useModalControl();
	const [isDownloading, setIsDownloading] = useState(false);

	const form = useForm({
		defaultValues: {
			hearings: [
				{
					title: "Hearing",
					type: "Hearing",
				},
			],
			case_types: [],
		},
	});
	const [searchTerm, setSearchTerm] = useState("");
	// const caseTypes = useSuspenseQuery(caseTypesQueryOptions({ search: searchTerm }));
	// const documents = caseTypes.data.data;

	const caseDownloadPrintedSchedule = caseDownloadPrintedScheduleMutation();
	const handleSubmit = async (id) => {
		const values = form.getValues();
		setIsDownloading(true);
		const response = await caseDownloadPrintedSchedule.mutateAsync({
			branchId: branchId,
			date: date,
			calendarIds: calendarIds,
			in_calendar: values.in_calendar,
			case_types: values.case_types,
		});

		const url = URL.createObjectURL(response);

		downloadFile(url, "hearing_schedule.pdf");
		setIsDownloading(false);
		closeModal();
	};

	return (
		<Form {...form}>
			<form className="w-full p-4" onSubmit={(e) => e.preventDefault()}>
				<div className="py-4">
					<h2 className="text-lg font-semibold"> Generate Hearing Schedule</h2>
				</div>

				{/* <div className="mt-4">
					<FormField
						control={form.control}
						name="case_types"
						render={({ field }) => (
							<FormItem>
								<div className="flex flex-col w-full">
									<FormLabel>Case Types</FormLabel>
								</div>
								<FormGroup>
									<TagsInput
										isMulti
										value={documents.filter((doc) => field.value?.includes(doc.id)).map((doc) => ({ label: doc.name, value: doc.id }))}
										onValueChange={(opts) => field.onChange(opts.map((opt) => opt.value))}
										loadOptions={async (input) => {
											const res = await apiClient.get("/case-types", {
												params: {
													"filter[search]": input,
												},
											});
											return res.data.data.map((item: { id: string; name: string }) => ({
												label: item.name,
												value: item.id,
											}));
										}}
									/>
								</FormGroup>
								<FormMessage />
							</FormItem>
						)}
					/>
				</div> */}
				<div className="mt-4">
					<FormField
						control={form.control}
						name="in_calendar"
						render={({ field }) => (
							<FormItem>
								<FormItem>
									<FormGroup>
										<div className="flex flex-row w-full gap-2 items-center">
											<FormControl>
												<Checkbox onCheckedChange={field.onChange} size="lg" />
											</FormControl>
											<FormLabel>
												<div className="flex flex-col w-full">
													<span className="text-sm text-muted-foreground">Include in calendar </span>
												</div>
											</FormLabel>
										</div>
									</FormGroup>
									<FormMessage />
								</FormItem>
							</FormItem>
						)}
					/>
				</div>

				<div className="flex justify-end gap-2 mt-6">
					<Button variant="ghost" onClick={closeModal} className="px-4 py-2">
						Cancel
					</Button>
					<Button variant="default" loading={isDownloading} onClick={form.handleSubmit(handleSubmit)} className="px-6 py-2">
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
